// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"5d736628","35":"18d208ca","323":"5d736628","351":"14de4f18","411":"8266aa7e","597":"c19eb49c","644":"d9cccef9","647":"bd9d4cfb","681":"d9cccef9","715":"d9cccef9","826":"2cdf383d"}[chunkId] + ".chunk.css";
};